import { TileTypes } from './constants'
import { cloneDeep, noop } from 'lodash'
import assert, {equal} from 'assert'

export function noAdjacentThreesInARow(grid: any) {
    let run = 0
    let foundThree = false
    for (let r = 0; r < grid.rows.length && !foundThree; r++) {
        run = 0
        const row = grid.rows[r];
        let last = TileTypes.Empty
        for (let i = 0; i < row.tiles.length; i++) {
            const tile = row.tiles[i]
            if (tile.tileType === TileTypes.Empty) {
                run = 0
                continue
            }
            if (tile.tileType === last) {
                run++
                if (run === 3) {
                    foundThree = true
                    break;
                }
            } else {
                run = 1
                last = tile.tileType
            }
        }
    }
    return run < 3
}

// startState: "BRBB RBEE BREE BBRR"
export function makeGrid(startState: any, onTileClick=noop) {
    startState = startState.replace(/\s+/g, '').toUpperCase()
    const size = Math.sqrt(startState.length)
    assert.ok(Number.isInteger(size), `startState needs to have a square number of elements. e.g. 16, 36, 64 etc`)
    const grid: {rows: any} = {rows: []}
    
    equal(startState.length, size*size, `startState has ${startState.length} tiles, while the grid has ${size*size} tiles`)

    let i = 0;
    for (let r = 0; r < size; r++) {
        grid.rows.push({tiles: []})
        for (let t = 0; t < size; t++) {
            const tile: any = {row: r, column: t, onClick: onTileClick}
            tile.tileType = startState[i] === 'B' ? TileTypes.Blue : 
                            startState[i] === 'R' ? TileTypes.Red  :
                                                    TileTypes.Empty
            tile.isLocked = tile.tileType !== TileTypes.Empty
            grid.rows[r].tiles.push(tile)
            i++
        }
    }
    return grid
}

function includes(haystack: any, locationNeedle:any) {
    const found = haystack.filter((strand:any) => (strand[0] === locationNeedle[0] && strand[1] === locationNeedle[1]))
    return found.length > 0
}

export function noAdjacentThreesInAColumn(grid:any) {
    const transposedGrid = transposeGrid(grid)
    return noAdjacentThreesInARow(transposedGrid)
}

export function areGridsEqual(grid1:any, grid2:any) {
    if (grid1.rows.length !== grid2.rows.length) {
        return false
    }
    for (let r = 0; r < grid1.rows.length; r++) {
        const row1 = grid1.rows[r];
        const row2 = grid2.rows[r];
        if (row1.tiles.length !== row2.tiles.length) {
            return false
        }
        for (let t = 0; t < row1.tiles.length; t++) {
            const tile1 = row1.tiles[t];
            const tile2 = row2.tiles[t];
            if (tile1.row !== tile2.row ||
                tile1.column !== tile2.column ||
                tile1.tileType !== tile2.tileType ||
                tile1.isLocked !== tile2.isLocked) {
                return false
            }

        }
    }
    return true
}

export function equalRedsAndBluesInEachRow(grid:any) {
    const rowReports = grid.rows.map((r: any) => {
        return {
            blueCount: r.tiles.filter((t: any) => t.tileType === TileTypes.Blue).length,
            redCount: r.tiles.filter((t: any) => t.tileType === TileTypes.Red).length
        }
    })
    const rowSize = grid.rows[0].tiles.length
    const badRows = rowReports.filter((rr: any) => rr.blueCount !== rowSize / 2 || rr.redCount !== rowSize / 2)
    return badRows.length === 0
}

export function equalRedsAndBluesInEachColumn(grid: any) {
    const transposedGrid = transposeGrid(grid)
    return equalRedsAndBluesInEachRow(transposedGrid)
}

export function noDuplicateRows(grid: any) {
    // for each row, find same row below it
    // if found, return false
    // at the end, return true
    for (let r = 0; r < grid.rows.length; r++) {
        const row = grid.rows[r];
        const same = findSameRowBelow(grid, r)
        if (same != null) {
            console.log('1', r)
            return false
        }
    }
    return true

    function findSameRowBelow(grid:any, rowNum:any) {
        for (let r = rowNum + 1; r < grid.rows.length; r++) {
            const row = grid.rows[r];
            if (areRowsSameType(grid.rows[rowNum], row)) {
                
                // console.log('row', grid.rows[rowNum], row)
                return row
            }
        }
        return null
    }

    

}

export function areRowsSameType(row1:any, row2:any) {
    if (row1.tiles.length !== row2.tiles.length) {
        // console.log('2')
        return false
    }
    for (let t = 0; t < row1.tiles.length; t++) {
        const tile1 = row1.tiles[t];
        const tile2 = row2.tiles[t];
        if (tile1.tileType !== tile2.tileType) {
        // console.log('3')

            return false
        }
    }
    return true
}

export function noDuplicateColumns(grid:any) {
    const transposedGrid = transposeGrid(grid)
    return noDuplicateRows(transposedGrid)
}

export function transposeGrid(grid:any) {
    const transposedGrid: {rows: any} = {
        rows: []
    }
    for (let r = 0; r < grid.rows.length; r++) {
        const row: any = grid.rows[r];
        for (let t = 0; t < row.tiles.length; t++) {
            const tile: any = row.tiles[t];
            if (transposedGrid.rows[t] === undefined) {
                transposedGrid.rows[t] = { tiles: [] } as any
            }
            transposedGrid.rows[t].tiles[r] = cloneDeep(tile)
            transposedGrid.rows[t].tiles[r].row = t
            transposedGrid.rows[t].tiles[r].column = r
        }
    }
    return transposedGrid
}